module.exports = __webpack_public_path__ + "assets/img/solution10.2f5d2d50.png";